export default "__VITE_ASSET__BuluAGvW__"